import { findSpecificationById } from "./findSpecificationById";

/**
 * @param {ProductFront[]} productData
 * @param {number} specificationId
 * @returns {ProductFront}
 */
export const findProductFront = (productData, specificationId) => {
	return productData.find(p => findSpecificationById(p.specifications, specificationId));
};



// WEBPACK FOOTER //
// ./src/helpers/specification/findProductFront.js